import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { WebFormComponent } from './webform.component';

export const WebFormRoutes: Routes = [
    {
        path: 'internal/webform',
        component: WebFormComponent,
        canActivate: [AuthService],
    },
];
